// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationAlertId } from './FermentationAlert';
import { operatorId } from './Operator';
import { fermentationAlertChannelEnum } from './FermentationAlertChannelEnum';
import { z } from 'zod';
export const fermentationAlertNotificationId = (z.number());
export const fermentationAlertNotification = z.object({
    id: fermentationAlertNotificationId,
    alert_id: fermentationAlertId.nullable(),
    operator_id: operatorId,
    channel: fermentationAlertChannelEnum,
    to_number: z.string(),
    body: z.string(),
    created_at: z.date(),
    sent_at: z.date().nullable(),
    provider_id: z.string().nullable(),
    error: z.string().nullable(),
});
export const fermentationAlertNotificationInitializer = z.object({
    id: fermentationAlertNotificationId.optional(),
    alert_id: fermentationAlertId.optional().nullable(),
    operator_id: operatorId,
    channel: fermentationAlertChannelEnum,
    to_number: z.string(),
    body: z.string(),
    created_at: z.date().optional(),
    sent_at: z.date().optional().nullable(),
    provider_id: z.string().optional().nullable(),
    error: z.string().optional().nullable(),
});
export const fermentationAlertNotificationMutator = z.object({
    id: fermentationAlertNotificationId.optional(),
    alert_id: fermentationAlertId.optional().nullable(),
    operator_id: operatorId.optional(),
    channel: fermentationAlertChannelEnum.optional(),
    to_number: z.string().optional(),
    body: z.string().optional(),
    created_at: z.date().optional(),
    sent_at: z.date().optional().nullable(),
    provider_id: z.string().optional().nullable(),
    error: z.string().optional().nullable(),
});
//# sourceMappingURL=FermentationAlertNotification.js.map